import type { RespondentProps } from '@trinity/chat/types/project-surveys';
import { cx } from '@trinity/chat-components/utils';
// import { MaybeLink } from '@/components/presentation/MaybeLink';
// import { RespondentBaseballCard } from '@/components/BaseballCard';
import ViewAll from './ViewAll';
import styles from './style/CollapsableResponseItem.module.css';

export type CustomResponseItemProps = {
  className?: string;
  respondent: RespondentProps;
  renderItem: () => React.ReactNode;
  wrapClassName?: string;
};

export const CustomResponseItem = ({ className, respondent, renderItem, wrapClassName }: CustomResponseItemProps) => {
  return (
    <div className={cx(styles.root, className)}>
      <div className={cx(styles.wrap, wrapClassName)}>
        <div className={styles.textblock}>
          <div className={styles.comment}>
            {renderItem()}
            <div className={styles.author}>
              {/* <RespondentBaseballCard
                classes={{
                  container: styles.cardContainer,
                }}
                {...respondent}>
                <MaybeLink to={respondent.paths.profile}>
                  {respondent.user.name}
                </MaybeLink>
              </RespondentBaseballCard> */}
            </div>
          </div>

          <ViewAll
            onClick={respondent.onViewResponse}
            to={respondent.paths.response} />
        </div>
      </div>
    </div>
  );
};